const HelpContact = () => {
    return <div>Help & Contact </div>;
};

export default HelpContact;
